/* eslint-disable @typescript-eslint/no-use-before-define */
import { useEffect, useState } from "react";
import "./App.css";
import Router from "./routes/router";
import { baseRouterMap, useRouterConfig } from "@/routes/routerMap";
import { useStore } from "@/utilities/storeHook";
import { useLocation } from "react-router-dom";
import { getLocalStorage, getParameter, getQueryVariable, removeLocalStorage, setLocalStorage } from "./utilities/common";
import api from "./api";

export const App = () => {
  const location = useLocation();
  const { pathname } = location;
  const store = useStore();
  const { userStore } = store;
  const invitationType = getParameter("s");
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const source:any = getQueryVariable("state");
  const routes = useRouterConfig();
  const getCurrentInfo = () => {
    api.getUserInfo().then((res: any) => {
      if (res && res.data) {
        userStore.setUserInfo({ ...res.data, accountUsername: res.data?.mail ?? res.data?.userPrincipalName });
        setLocalStorage("isAuthenticated", true);
        setIsAuthenticated(true);
      } else {
        setLocalStorage("isAuthenticated", false);
        setIsAuthenticated(false);
      }
    });
  };

  useEffect(() => {
    if (source && source?.indexOf("register_ms_email") !== -1) {
      setLocalStorage("loginOption", JSON.stringify({
        signUp: true,
        signIn: false
      }));
      removeLocalStorage("userInfo");
    }
  }, [source]);
  useEffect(() => {
    if (!getLocalStorage("loginOption")) {
      setLocalStorage("loginOption", JSON.stringify({
        signUp: false,
        signIn: true
      }));
    }
    if (!invitationType) {
      if (getQueryVariable("code") && getQueryVariable("state")) {
        if (getLocalStorage("userInfo") !== null) {
          let data: { email: string; redirectUri?: string } = {
            email: JSON.parse(getLocalStorage("userInfo") || "{}")?.accountUsername
          };
          data = process.env.NODE_ENV === "development" ? { ...data, redirectUri: process.env.REDIRECTURL } : { ...data };
          api.CrossBorder.getEndpoint(data).then((res: any) => {
            getCurrentInfo();
          });
        } else {
          getCurrentInfo();
        }
      } else {
        setIsAuthenticated(getLocalStorage("isAuthenticated") === "true");
      }
    }
  }, [isAuthenticated, userStore.isGotUserInfo, pathname]);

  return (
    <>
      <Router routes={isAuthenticated ? routes : baseRouterMap}></Router>
    </>
  );
};
